<template>
    <div class="administration">
        <div class="administration-login" v-if="statusChecked">
            <img src="/static/img/admin/logo.png" alt="Alcomet administration">
            <form class="administration-login-form" @submit.prevent="login">
                <!-- <label>Username</label> -->
                <input class="administration-input" required v-model="user.username" type="text" placeholder="Потребител"/>
                <!-- <label>Password</label> -->
                <input class="administration-input" required v-model="user.password" type="password" placeholder="Парола"/>
                <button class="administration-submit" type="submit" :disabled="isSubmitting">
                  {{ isSubmitting ? "Влизане..." : "Вход" }}
                </button>
                <p class="administration-error" v-if="errorMessage">{{ errorMessage }}</p>
            </form>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      statusChecked: false,
      isSubmitting: false,
      errorMessage: "",
      user: {
        username: "",
        password: ""
      }
    };
  },
  methods: {
    login() {
      this.isSubmitting = true;
      this.errorMessage = "";

      this.$http({
        url: `${process.env.ROOT_API}/admin/login`,
        data: this.user,
        method: "POST"
      })
        .then(resp => {
          localStorage.setItem("token", resp.data.token);
          this.user = {
            username: "",
            password: ""
          };
          this.isLoggedIn();
        })
        .catch(err => {
          localStorage.removeItem("token");
          this.isSubmitting = false;

          if (err.response && err.response.status === 401) {
            this.errorMessage = "Невалиден потребител или парола.";
          } else {
            this.errorMessage = "Входът е временно недостъпен. Моля, опитайте отново.";
          }
        });
    },
    isLoggedIn() {
      this.statusChecked = false;
      const token = localStorage.getItem("token");
      this.$http({
        url: `${process.env.ROOT_API}/admin/validate`,
        data: { token: token },
        method: "POST"
      })
        .then(res => {
          if (res.data.user) {
            // this.currentlyLoggedUser = res.data.user;
            this.$router.push("/admin");
          } else {
            this.isSubmitting = false;
            this.statusChecked = true;
          }
        })
        .catch(err => {
          console.log(err);
          this.isSubmitting = false;
          this.statusChecked = true;
        });
    }
  },
  mounted() {
    this.isLoggedIn();
  }
};
</script>

<style scoped>
.administration {
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 100vh;
  min-width: 1000px;
}
.administration-login {
  align-items: center;
  background-image: url("/static/img/admin/bg.jpg");
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100vh;
  width: 100%;
}
.administration-login-form {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 15px;
}
.administration-input,
.administration-submit {
  color: #000;
  height: 50px;
  margin: 5px 0;
  width: 280px;
}
.administration-input {
  padding: 0 15px;
}
.administration-submit {
  background-color: #2ea4d7;
  border: none;
  color: #fff;
  cursor: pointer;
  display: block;
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.administration-submit:hover {
  background-color: #3099c6;
}
.administration-submit:disabled {
  cursor: default;
  opacity: 0.7;
}
.administration-error {
  color: #c0392b;
  margin-top: 10px;
  text-align: center;
  width: 280px;
}
.administration-panel {
  min-height: 100vh;
  width: 100%;
}
.administration-header {
  align-items: center;
  background-color: #2ea4d7;
  display: flex;
  height: 60px;
  justify-content: space-between;
  padding-left: 40px;
  width: 100%;
}
.administration-header p {
  color: #fff;
}
.administration-logout {
  align-items: center;
  background-color: #2ea4d7;
  color: #fff;
  display: flex;
  height: 100%;
  padding: 0 40px;
}
.administration-logout:hover {
  background-color: #3099c6;
}
.administration-content {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 60px 40px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/administration/AdministrationLogin.vue